import qs from 'query-string';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import useStaticData from './useStaticData';

const useSelectedFilters = (cloud) => {
  const location = useLocation();
  const categories = useStaticData('categories', cloud);

  const selectedFilters = useMemo(() => {
    const parsedSearch = qs.parse(location.search);
    const filterKeys = [...(categories?.keys() ?? [])];
    const returnedValue = Object.keys(parsedSearch)
      .filter((key) => filterKeys.includes(key))
      .reduce(
        (res, key) => (
          Array.isArray(parsedSearch[key])
            ? (res[key] = parsedSearch[key].map((val) => ({ name: val })))
            : (res[key] = [{ name: parsedSearch[key] }]),
          res
        ),
        {}
      );
    return returnedValue;
  }, [location.search, categories]);

  return selectedFilters;
};

export default useSelectedFilters;
